module.exports = __webpack_public_path__ + "static/static-2166716f19fdd535a738dd4f4f5ebe08.jpg";